/**
 * The Live tab's head line (20/10/2026): what the tab is, the Rows | Cards
 * switch, Evaluate verdicts and the link to today's drafts.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { ExternalLink, Scale } from 'lucide-react';

import { type LiveLayout } from './live-layout';
import { LiveLayoutToggle } from './LiveLayoutToggle';

interface Props {
  layout: LiveLayout;
  onLayout: (layout: LiveLayout) => void;
  draftsHref: string | null;
  onEvaluate?: () => void;
  evaluating: boolean;
}

export const LiveHeader: FC<Props> = ({ layout, onLayout, draftsHref, onEvaluate, evaluating }) => (
  <div className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
    <span>Live — the day as it actually stands; the Day timeline stays the blueprint.</span>
    <span className="grow" />
    <LiveLayoutToggle value={layout} onChange={onLayout} />
    {onEvaluate ? (
      <button
        type="button"
        onClick={onEvaluate}
        disabled={evaluating}
        title="Collect today's stats, judge every container with verdicts on, and act: burn a terrible list, stop a group's day when its container says so"
        className="inline-flex items-center gap-1 rounded-md border border-input px-2.5 py-1 font-medium text-muted-foreground hover:bg-muted hover:text-foreground disabled:opacity-50"
      >
        <Scale className="h-3 w-3" />
        {evaluating ? 'Evaluating…' : 'Evaluate verdicts'}
      </button>
    ) : null}
    {draftsHref ? (
      <a href={draftsHref} className="inline-flex items-center gap-1 font-medium text-primary hover:underline">
        Open today&apos;s drafts <ExternalLink className="h-3 w-3" />
      </a>
    ) : null}
  </div>
);
